// extracted by mini-css-extract-plugin
export default {"inputButton":"add-participant-dialog_inputButton__F5XI9"};